import { createSlice } from '@reduxjs/toolkit';
import {UserFeedbackState} from "../interfaces";

const initialState : UserFeedbackState = {
    isOpen: false,
    type: 'info',
    message: '',
    title: '',
    buttonTitle: ''
};

export const userFeedbackSlice = createSlice({
    name: 'userFeedback',
    initialState,
    reducers: {
        showUserFeedback: (state, action) => {
            state.isOpen = true;
            state.type = action.payload.type;
            state.message = action.payload.message || '';
            state.title = action.payload.title || '';
            state.buttonTitle = action.payload.buttonTitle || '';
        },
        hideUserFeedback: (state) => {
            state.isOpen = false;
            state.message = '';
            state.title = '';
            state.type = 'info';
            state.buttonTitle = '';
        },
    }
});
export default userFeedbackSlice.reducer;
